interface Props extends React.SVGProps<SVGSVGElement> {
  size?: string;
}

export default function Password({ size = "16", ...props }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 16 17"
      fill="none"
      {...props}
    >
      <g opacity="0.5">
        <path
          d="M8 1.5C8.53043 1.5 9.03914 1.71071 9.41421 2.08579C9.78929 2.46086 10 2.96957 10 3.5V7.5H6V3.5C6 2.96957 6.21071 2.46086 6.58579 2.08579C6.96086 1.71071 7.46957 1.5 8 1.5ZM11 7.5V3.5C11 2.70435 10.6839 1.94129 10.1213 1.37868C9.55871 0.81607 8.79565 0.5 8 0.5C7.20435 0.5 6.44129 0.81607 5.87868 1.37868C5.31607 1.94129 5 2.70435 5 3.5V7.5C4.46957 7.5 3.96086 7.71071 3.58579 8.08579C3.21071 8.46086 3 8.96957 3 9.5V14.5C3 15.0304 3.21071 15.5391 3.58579 15.9142C3.96086 16.2893 4.46957 16.5 5 16.5H11C11.5304 16.5 12.0391 16.2893 12.4142 15.9142C12.7893 15.5391 13 15.0304 13 14.5V9.5C13 8.96957 12.7893 8.46086 12.4142 8.08579C12.0391 7.71071 11.5304 7.5 11 7.5Z"
          fill="#061425"
        />
      </g>
    </svg>
  );
}
